import { Component } from '@angular/core';

@Component({
  selector: 'charge-card',
  templateUrl: './charge-card.component.html',
  styleUrls: ['./charge-card.component.sass']
})
export class ChargeCardComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/demo/charge-card/charge-card.component.ts